import ConditionalView from "components/ConditionalView"
// import cn from "classnames"
import { cn } from "lib/utils"

const Wrapper = (props: any) => {
  const hasLabel = !props.noLabel && props.label
  const errorClass = cn(
    `pointer-events-none absolute border-[1px] left-0 bottom-0 border-solid border-red-500`,
    {
      [` top-[33px] right-0`]: hasLabel,
      [` top-0`]: !hasLabel,
      [` right-6`]: !hasLabel && !props.errorClass?.includes?.("right-0"),
      [props.errorClass]: !!props.errorClass,
    }
  )
  return (
    <div
      className={cn(
        "flex-c-box",
        "w-full",
        "relative",
        { "mb-2": !!props.error },
        props.className
      )}
    >
      <ConditionalView condition={hasLabel}>
        <span
          className={cn("mb-2 font-bold text-primary-text", props.labelClass)}
        >
          {props.label}
        </span>
      </ConditionalView>
      {props.children}
      <ConditionalView condition={!!props.error}>
        <>
          <div className={errorClass} />
          <span className="text-xs absolute left-0 -bottom-4 text-red-500 whitespace-nowrap">
            {props.error}
          </span>
        </>
      </ConditionalView>
    </div>
  )
}

export default Wrapper
